import React, { FC, useContext, useEffect, useState } from 'react';
import cnBind from 'classnames/bind';
import { FormikValues } from 'formik';
import { useStoreon } from 'storeon/react';
import { GxIcon } from '@garpix/garpix-web-components-react';

import { Events, State } from '@/interfaces';
import {
  ContextDeposit,
  headerItems,
  SIDEBAR_TYPES,
  sidebarItems,
  TYPES,
} from './const';
import ModalLayout from '../../../../components/ModalLayout';
import Basket from './Basket/Basket';
import DepositComponent from './components/DepositComponent/DepositComponent';
import ServicesComponent from './components/ServicesComponent/ServicesComponent';
import ModalPayHere from './components/ModalPayHere';
import useModalFlag from '../../../../hooks/useModalFlag';
import { priceInfoDepositPayHere } from './helpers';
import { FlyIcon } from '../../../../assets';
import CertificateComponent from './components/CertificateComponent/CertificateComponent';
import { Context } from '../ModalUser/Context';
import { createPaymentCertificate, createPaymentDeposit, createPaymentServices } from '../../helpers';
import { TYPE_USER } from '../../../../const';

import styles from './styles/index.module.scss';

interface IModalPayCertificateOrDeposit {
  flag: boolean;
  onRequestClose: () => void;
  userData?: any;
}

const ModalPayCertificateOrDeposit: FC<IModalPayCertificateOrDeposit> = ({
  flag,
  onRequestClose,
  userData,
}) => {
  const [activeHeaderItem, setActiveHeaderItem] = useState(TYPES.CERTIFICATES);
  const { dispatch, currentUser } = useStoreon<State, Events>('currentUser');
  const [activeSideBarItem, setActiveSideBarItem] = useState(
    activeHeaderItem === TYPES.CERTIFICATES
      ? SIDEBAR_TYPES.PIPE
      : SIDEBAR_TYPES.MONEY
  );
  const [activeItem, setActiveItem] = useState<Record<string, any> | null>(
    null
  );
  const [stockInfo, setStockInfo] = useState<any>();
  const [count, setCount] = useState<number>(1);
  const { flag: flagModal, setModalFlag } = useModalFlag();
  const [priceInfo, setPriceInfo] = useState<Record<string, any>>(
    priceInfoDepositPayHere(activeItem, count, 0)
  );
  const { first_name, last_name, id } = userData;
  const [isBill, setIsBill] = useState<any>({ flag: false, link: '' });
  const [, getUserData] = useContext<any>(Context);

  const cn = cnBind.bind(styles);
  const handleClickPayHere = (data: Record<string, any>) => {
    setPriceInfo(data);
    setModalFlag();
  };

  
  const handleClickOnline = async (formik: FormikValues) => {
    const isSuperUser = currentUser?.user_status === TYPE_USER.SUPERUSER

    const value =
      activeHeaderItem === TYPES.CERTIFICATES
        ? activeItem?.title
        : activeSideBarItem === SIDEBAR_TYPES.MONEY
          ? activeItem?.name
          : activeItem?.rate_name ?? activeItem?.title;

    let info = {
      user_id: id,
      deposit_tariff_rate_id:
        activeSideBarItem !== 0 && activeItem?.rent_pay_count === undefined ? activeItem?.id : undefined,
      rent_rate_id: activeItem?.rent_pay_count ? activeItem.id : undefined,
      service_id:
        activeHeaderItem === TYPES.SERVICES ? activeItem?.id : undefined,
      money_deposit_rate_id:
        activeSideBarItem === 0 ? activeItem?.id : undefined,
      session_timeout_secs: Math.trunc(formik.values.sessionTimeoutSecs) * 60,
      stock_id: stockInfo ? stockInfo.id : undefined,
      resource:
        isSuperUser
          ? formik.values.resource
          : undefined,
      price:
        isSuperUser ||
          (activeSideBarItem === SIDEBAR_TYPES.MONEY &&
            formik.values.base_price !== Number(activeItem?.balance))
          ? formik.values.base_price
          : undefined,
      count: activeHeaderItem === TYPES.SERVICES || activeSideBarItem !== SIDEBAR_TYPES.MONEY
        ? count 
        : undefined,
      payments: [{ payment_method: 4 }],
    };
    if (activeHeaderItem === TYPES.CERTIFICATES) {
      const onlineCertificate = {
        user: id,
        certificate_generator: activeItem?.id,
        stock_id: stockInfo ? stockInfo.id : undefined,
        comment:
          formik.values.comment !== '' ? formik.values.comment : undefined,
        certificate_party:
          formik.values.certificate_party !== ''
            ? formik.values.certificate_party
            : undefined,
        price:
          isSuperUser
            ? formik.values.base_price
            : undefined,
        pay_link_timeout: formik.values.sessionTimeoutSecs * 60,
        count: activeSideBarItem !== SIDEBAR_TYPES.MONEY ? count : undefined,
        payments: [{ payment_method: 4 }],
        set_number_series: formik.values.set_number_series,
        number_series: formik.values.set_number_series ? [
          {
            number: formik.values.number_series.number,
            series: formik.values.number_series.series,
          }
        ] : undefined,

      };
      await createPaymentCertificate(onlineCertificate, value, setIsBill);
    } else if (activeHeaderItem === TYPES.DEPOSITS) {
      // @ts-ignore
      await createPaymentDeposit(info, value, formik, setIsBill);
    } else {
      await createPaymentServices(info, value, formik, setIsBill);
    }
    // setOnlineInfo(info)
  };
  const handleClickItem = (data: Record<string, any>) => {
    setActiveItem(data);
    setIsBill({ flag: false, link: '' });
    setStockInfo(undefined);
  };

  const onClosePayModal = () => {
    setModalFlag()
    setActiveItem(null)
  }

  useEffect(() => {
    setCount(1);
  }, [activeItem]);

  useEffect(() => {
    if (currentUser?.user_status !== TYPE_USER.VIEWER) {
      dispatch('depositListPattern/get', { user_id: id });
    }
    dispatch('services/get', { service_type: 0, is_active: true })
  }, []);

  const tabsSwitch = (params: any): React.ReactNode => {
    switch (params) {
      case TYPES.CERTIFICATES:
        return <CertificateComponent
          activeSideBarItem={activeSideBarItem}
          clickItem={handleClickItem}
          activeItem={activeItem}
          setCount={setCount}
          count={count}
        />
      case TYPES.DEPOSITS:
        return <DepositComponent
          activeSideBarItem={activeSideBarItem}
          clickItem={handleClickItem}
          activeItem={activeItem}
          setCount={setCount}
          count={count}
        />
      case TYPES.SERVICES:
        return <ServicesComponent
          activeSideBarItem={activeSideBarItem}
          clickItem={handleClickItem}
          activeItem={activeItem}
          setCount={setCount}
          count={count}
        />
      default:
        return <CertificateComponent
          activeSideBarItem={activeSideBarItem}
          clickItem={handleClickItem}
          activeItem={activeItem}
          setCount={setCount}
          count={count}
        />
    }
  }

  return (
    <ContextDeposit.Provider
      value={[isBill, setIsBill, stockInfo, setStockInfo]}
    >
      <ModalLayout
        flag={flag}
        onClose={() => {
          onRequestClose();
          getUserData(id);
        }}
        size='lg'
      >
        <div className={styles['header']}>
          <p className={styles['header--subtitle']}>Продажа</p>
          <p className={styles['header--text']}>
            Для: {first_name} {last_name}
          </p>
        </div>
        <div className={styles['wrapper']}>
          <div className={styles['section']}>
            <div className={styles['section__header']}>
              {headerItems.map((item) => (
                <button
                  key={item.id}
                  className={cn({
                    section__header_item: true,
                    'section__header_item--active':
                      activeHeaderItem === item.id,
                  })}
                  type='button'
                  onClick={() => {
                    setActiveHeaderItem(item.id);
                    setActiveSideBarItem(
                      item.id === TYPES.CERTIFICATES
                        ? SIDEBAR_TYPES.PIPE
                        : SIDEBAR_TYPES.MONEY
                    );
                    setActiveItem(null);
                  }}
                >
                  {item.label}
                </button>
              ))}
            </div>
            <div className={styles['section__wrapper']}>
              <div className={styles['sidebar']}>
                {activeHeaderItem !== TYPES.SERVICES && sidebarItems
                  .filter((el: Record<string, any>) =>
                    activeHeaderItem === TYPES.CERTIFICATES
                      ? el.id !== SIDEBAR_TYPES.MONEY
                      : el.id !== SIDEBAR_TYPES.HYBRID
                  )
                  .map((item: Record<string, any>) => (
                    <button
                      key={item.id}
                      className={cn({
                        sidebar_item: true,
                        'sidebar_item--active': activeSideBarItem === item.id,
                      })}
                      type='button'
                      onClick={() => {
                        setActiveSideBarItem(item.id);
                        setActiveItem(null);
                      }}
                    >
                      {item.id === SIDEBAR_TYPES.HYBRID && (
                        <GxIcon
                          src={FlyIcon}
                          className={styles['sidebar_item--icon']}
                        />
                      )}
                      <GxIcon
                        src={item.icon}
                        className={styles['sidebar_item--icon']}
                      />
                    </button>
                  ))}
              </div>
              <div className={styles['section__container']}>
                <p className={styles['section__container--title']}>
                  {activeHeaderItem !== TYPES.SERVICES ? sidebarItems[activeSideBarItem].label : null}
                </p>{
                  tabsSwitch(activeHeaderItem)
                }
              </div>
            </div>
          </div>
          <Basket
            activeItem={activeItem}
            count={count}
            activeSideBarItem={activeSideBarItem}
            activeHeaderItem={activeHeaderItem}
            handleClickOnline={handleClickOnline}
            userId={id}
            modalClose={() => {
              onRequestClose();
              getUserData(id);
            }}
            setModalFlag={handleClickPayHere}
          />
        </div>
      </ModalLayout>
      <ModalPayHere
        data={activeItem ?? {}}
        priceInfo={priceInfo}
        flag={flagModal}
        onRequestClose={onClosePayModal}
        count={count}
        userInfo={userData}
        deposit_type={activeSideBarItem}
        headerType={activeHeaderItem}
      />
    </ContextDeposit.Provider>
  );
};

export default ModalPayCertificateOrDeposit;
